export default function AboutSection() {
  const features = [
    {
      icon: 'ri-database-2-line',
      title: 'Spreadsheet Database',
      desc: 'Access comprehensive BaseTao Spreadsheet databases with curated product links, QC references, and organized research data for smarter shopping.',
      image: 'https://readdy.ai/api/search-image?query=Multiple%20monitor%20setup%20displaying%20organized%20data%20tables%20and%20product%20spreadsheets%2C%20modern%20tech%20workspace%20with%20warm%20desk%20lamp%2C%20potted%20succulent%20plant%20on%20side%2C%20soft%20evening%20ambient%20light%2C%20cozy%20productive%20atmosphere%2C%20warm%20wood%20and%20sage%20green%20tones%2C%20editorial%20tech%20office%20photography&width=600&height=400&seq=about-db-v2&orientation=landscape',
    },
    {
      icon: 'ri-star-line',
      title: 'Honest Reviews',
      desc: 'Read unbiased BaseTao Spreadsheet reviews from real users. We analyze features, usability, and value to help you make informed decisions.',
      image: 'https://readdy.ai/api/search-image?query=Person%20reading%20product%20reviews%20on%20tablet%20device%20while%20taking%20notes%20on%20paper%2C%20cozy%20cafe%20setting%20with%20warm%20ambient%20lighting%2C%20golden%20hour%20sunlight%20through%20window%2C%20relaxed%20research%20vibe%2C%20warm%20caramel%20and%20cream%20tones%2C%20editorial%20lifestyle%20photography&width=600&height=400&seq=about-review-v2&orientation=landscape',
    },
    {
      icon: 'ri-ship-line',
      title: 'Shipping Cost Analysis',
      desc: 'Detailed breakdowns of BaseTao shipping costs for USA, UK, Europe, and worldwide. Compare DHL, EMS, and economy options to find the best rates.',
      image: 'https://readdy.ai/api/search-image?query=International%20parcels%20and%20shipping%20boxes%20stacked%20on%20light%20wooden%20floor%20near%20large%20world%20map%20wall%20art%2C%20measuring%20tape%20draped%20across%20packages%2C%20bright%20airy%20room%20with%20natural%20daylight%2C%20organized%20logistics%20theme%2C%20warm%20earth%20and%20cream%20tones%2C%20editorial%20commercial%20photography&width=600&height=400&seq=about-ship-v2&orientation=landscape',
    },
    {
      icon: 'ri-coupon-line',
      title: 'Discount Codes',
      desc: 'Stay updated with the latest BaseTao coupons, promo codes, and seasonal discounts. Learn how to save money on every order with verified deals.',
      image: 'https://readdy.ai/api/search-image?query=Golden%20scissors%20cutting%20through%20price%20tag%20on%20warm%20terracotta%20surface%2C%20scattered%20colorful%20discount%20labels%20around%2C%20soft%20morning%20sunlight%20creating%20gentle%20shadows%2C%20savings%20and%20bargain%20concept%2C%20warm%20amber%20and%20coral%20tones%2C%20editorial%20conceptual%20still%20life%20photography&width=600&height=400&seq=about-coupon-v2&orientation=landscape',
    },
    {
      icon: 'ri-building-line',
      title: 'Warehouse Guide',
      desc: 'Understand how BaseTao warehouse operations work — from product receiving and QC photos to storage time and international consolidation.',
      image: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20modern%20warehouse%20interior%20with%20labeled%20shelves%20and%20cardboard%20boxes%2C%20worker%20in%20background%20checking%20clipboard%2C%20soft%20industrial%20lighting%20through%20skylight%2C%20clean%20professional%20logistics%20facility%2C%20warm%20neutral%20tones%20with%20subtle%20green%20accents%2C%20editorial%20supply%20chain%20photography&width=600&height=400&seq=about-warehouse-v2&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety & Legitimacy',
      desc: 'Comprehensive analysis of BaseTao platform safety, payment security, and legitimacy. Get the facts before you start shopping internationally.',
      image: 'https://readdy.ai/api/search-image?query=Polished%20brass%20padlock%20standing%20upright%20on%20light%20sandstone%20surface%20with%20soft%20natural%20light%20casting%20long%20elegant%20shadow%2C%20trust%20and%20security%20symbolism%2C%20clean%20minimalist%20composition%2C%20warm%20gold%20and%20ivory%20tones%2C%20editorial%20conceptual%20product%20photography&width=600&height=400&seq=about-safety-v2&orientation=landscape',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-medium mb-4">
            <i className="ri-compass-3-line"></i>
            <span>Research Hub</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Everything About BaseTao Spreadsheet
          </h2>
          <p className="text-sm text-foreground-600 max-w-[550px] mx-auto">
            Your complete resource center for mastering BaseTao Spreadsheet — from product discovery to international shipping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={f.image}
                  alt={f.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/20 to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <div className="w-10 h-10 rounded-lg bg-background-50/90 backdrop-blur-sm flex items-center justify-center mb-2">
                    <i className={`${f.icon} text-lg text-primary-600`}></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1.5">{f.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}